var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRescheduleAppointment = function SvgIconRescheduleAppointment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h23.997v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16.998 23h-3v-3l6-6 2.999 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M22.998 3.002H18v-2a1 1 0 1 0-2 0v2H8.001v-2a.945.945 0 0 0-1-1 .945.945 0 0 0-1 1v2H1a.945.945 0 0 0-1 1v18a.945.945 0 0 0 1 1h10v-2H2v-14h20v5h2v-8a.945.945 0 0 0-1-1z"
  }))));
};
export { SvgIconRescheduleAppointment as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgb3BhY2l0eT0iLjUiPgogICAgICAgIDxwYXRoIGQ9Ik0wIDBoMjMuOTk3djI0SDB6Ii8+CiAgICAgICAgPHBhdGggc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTE2Ljk5OCAyM2gtM3YtM2w2LTYgMi45OTkgM3oiLz4KICAgICAgICA8cGF0aCBkPSJNMjIuOTk4IDMuMDAySDE4di0yYTEgMSAwIDEgMC0yIDB2Mkg4LjAwMXYtMmEuOTQ1Ljk0NSAwIDAgMC0xLTEgLjk0NS45NDUgMCAwIDAtMSAxdjJIMWEuOTQ1Ljk0NSAwIDAgMC0xIDF2MThhLjk0NS45NDUgMCAwIDAgMSAxaDEwdi0ySDJ2LTE0SDIydjVoMnYtOGEuOTQ1Ljk0NSAwIDAgMC0xLTF6IiBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz4KICAgIDwvZz4KPC9zdmc+Cg==";